import { TextField, FormHelperText } from '@mui/material';

interface IProps {
    Name: string;
    PlaceHolder: string;
    Label: string;
    Value: string;
    OnChange?: (e: any) => void;
    HelperText?: string;
}

export default function BasicTextFields (props: IProps) {

    return (
        <>
            <TextField
                name={props.Name}
                placeholder={props.PlaceHolder}
                label={props.Label}
                variant="outlined"
                size="small"
                fullWidth
                value={props.Value}
                onChange={props.OnChange}
                InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                className="bg-color-primary-text-field"
                autoComplete='no' />
            <FormHelperText className={"h5-regular color-primary-danger t-align-right"}>
                {props.HelperText}
            </FormHelperText>
        </>

    );
}
